import { mutatorAction } from "satcheljs";
import { getProactiveDraftsStore } from "../store/store";

const setProactiveDraftsBarVisibleMutator: (itemId: string | undefined, isVisible: boolean) => void = mutatorAction("setProactiveDraftsBarVisibleMutator", function setProactiveDraftsBarVisible(itemId: string | undefined, isVisible: boolean): void {
    if (!itemId) {
        return;
    }
    
    // Set the proactive drafts bar expanded/collapsed state for the given key
    const proactiveDraftsStore = getProactiveDraftsStore();
    const proactiveDraftsState = proactiveDraftsStore.proactiveDraftsListMap.get(itemId);
    if (proactiveDraftsState) {
        proactiveDraftsState.proactiveDraftsBarVisible = isVisible;
    }
});
export default setProactiveDraftsBarVisibleMutator;
